import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import { Control, Errors, Form } from 'react-redux-form';
import Select from '../../common/form/filtered-dropdown';
import Datepicker from '../../common/form/datepicker';

class DelinkForm extends Component {
  constructor(props) {
    super(props);

    this.id = this.props.outletId;
  }

  static renderFooter() {
    return (
      <div className="fluid text-right">
        <Button className="btn red-ghost-btn" type="submit">
          Next
        </Button>
      </div>
    );
  }

  render() {
    const {outlets} = this.props;
    const value = this.props.selectedOutlet === undefined ? {
      value: '',
      label: ''
    } : {
      value: this.props.selectedOutlet.id,
      label: this.props.selectedOutlet.attributes.name
    };

    return (
      <Form model='deep.admin_delink' onSubmit={payLoad => this.props.handleSubmit(payLoad, outlets)}>
        <Errors className="errors" model="deep.admin_delink"/>
        <Panel className="mg-top-20" footer={DelinkForm.renderFooter()}>
          <FormGroup controlId="outlet">
            <label>
              Delink Single Outlet
            </label>
            <Select
              data={this.props.outlets.map(v => ({
                value: v.id,
                label: `${v.attributes['customer-number']} - ${v.attributes.name}`
              }))}
              isLoading={!this.props.fetched}
              model="deep.admin_delink.outlet"
              onChange={this.props.handleSelectChange}
              onInputChange={this.props.onInputChange}
              placeholder="Select Outlet"
              value={value}
            />
          </FormGroup>
          <FormGroup controlId="delink_date">
            <ControlLabel>
              Delink date*
            </ControlLabel>
            <Datepicker model="deep.admin_delink.delink_date"/>
          </FormGroup>
          <FormGroup controlId="delink_reason">
            <ControlLabel>
              Delink reason*
            </ControlLabel>
            <Control.text component={FormControl} model=".delink_reason" required/>
          </FormGroup>
          <FormGroup controlId="supress_notification">
            <label>
              <Control.checkbox model=".supress_notification"/>
              Suppress notifications
            </label>
          </FormGroup>
        </Panel>
      </Form>
    );
  }
}

export default (DelinkForm);



// WEBPACK FOOTER //
// ./src/components/admin/delink/delink-form.jsx